import { useCallbackRef, useToast } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useChatStateContext, useChatUpdateContext } from '@/components/ui/shared/conversation/Chat/Chat.context';

export const useMessageReply = (message, messageAttributes) => {
  const toast = useToast();
  const { t } = useTranslation();
  const { messageSid, value: storedInput } = useChatStateContext();
  const dispatch = useChatUpdateContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const ref = useRef<HTMLInputElement>();

  const onReply = async (value) => {
    setIsLoading(true);
    const text = `${value}`.trim();

    // Text message limit
    if (text.length >= 500) {
      toast({ title: t('conversation.errorSendingLongMessage'), status: 'error', isClosable: true });
      setIsLoading(false);
      return;
    }

    if (text !== '') {
      await message.conversation.sendMessage(value, messageAttributes);
    }

    setIsLoading(false);
    dispatch({ type: 'close' });
  };

  const onToggleReply = () => {
    dispatch(messageSid === message.sid ? { type: 'close' } : { type: 'open', messageSid: message.sid });

    setTimeout(() => {
      if (ref.current) {
        ref.current.scrollIntoView({ block: 'nearest' });
        ref.current.focus();
      }
    });
  };

  const storeInput = useCallbackRef((value) => {
    dispatch({ type: 'storeInput', value });
  });

  return {
    onReply,
    storedInput,
    storeInput,
    isLoading,
    onToggleReply,
    isReplyVisible: messageSid === message.sid,
    inputProps: { ref },
  };
};
